import { BaseCollection } from './base-collection.model';
import { PingView } from './ping.model';

export enum PhoneReportTestType {
  LNT = 'LNT',
  MNT = 'MNT',
}

export enum PhoneReportConnectivityStatus {
  UNAVAILABLE = 'unavailable', // no data / not applicable
  COLLECTING = 'collecting', // TTL window not finished yet
  OK = 'ok', // all pings present, strength OK+
  WARNING = 'warning', // missing pings and/or degraded strength
}

export enum PhoneReportConnectivityIssueType {
  MISSING_PING = 'missingPing',
  IRREGULAR_INTERVAL = 'irregularInterval',
  DEGRADED_SIGNAL = 'degradedSignal',
}

export enum PhoneReportIssue {
  DOES_NOT_SHOW = 'DOES_NOT_SHOW',
  EXPIRED_SIM = 'EXPIRED_SIM',
  WHITELISTED = 'WHITELISTED',
  PORTED = 'PORTED',
}

export interface PhoneReportConnectivityInfo {
  status: PhoneReportConnectivityStatus;
  description: string;
  issues: PhoneReportConnectivityIssueDetails[];
}

export interface PhoneReportConnectivityIssueDetails {
  type: PhoneReportConnectivityIssueType;
  details: string | null;
  timestampCurrent: Date;
  timestampPrev: Date | null;
}

export interface PhoneReport {
  id: number;
  createdAt: Date;
  phone: string;
  testId: number | null;
  testType: PhoneReportTestType | null;
  testTtl: number | null;
  testCreatedAt: Date | null;
  pingsCollected: boolean;
  pings: PingView[];
  issue: PhoneReportIssue;
  description: string;
  userFullName: string;
  username: string;
  userEmail: string;
  companyName: string;
  backupTestId: number | null;
  backupTestMessageState: string | null;
  backupTestStatus: string | null;
  outcomeResolution: PhoneReportOutcomeResolutionEnum | null;
  outcomeDescription: string | null;
}

export enum PhoneReportOutcomeResolutionEnum {
  UNDER_REVIEW = 'UNDER_REVIEW',
  EXTERNAL_NUMBER = 'EXTERNAL_NUMBER',
  GHOST_PROBLEM = 'GHOST_PROBLEM',
  NETWORK_ISSUE = 'NETWORK_ISSUE',
  NO_ISSUE = 'NO_ISSUE',
  NUMBER_ISSUE = 'NUMBER_ISSUE',
}

export interface PhoneReportCreate {
  description?: string;
  phone?: string;
  issue?: string;
  testId?: number;
  testType?: PhoneReportTestType;
}

export interface PhoneReportCollection extends BaseCollection {
  content: PhoneReport[];
}

export interface PhoneReportOutcomeUpdateRequest {
  outcomeResolution: PhoneReportOutcomeResolutionEnum | null;
  outcomeDescription: string | null;
}

export interface PhoneReportOutcomeOutput {
  id: number;
  outcomeResolution: PhoneReportOutcomeResolutionEnum;
  outcomeDescription: string;
}

export interface PhoneReportsByTestsIdsRequestDto {
  testIds: number[];
  testType: PhoneReportTestType;
}

export interface PhoneReportByTestIdInfo {
  testId: number;
  testType: PhoneReportTestType;
}
